import { Utilities } from 'core';
import { Loader, Notification } from 'ui/containers';
import { LoaderFullScreen, StackNavigatorProvider } from 'ui/components';
import { Routes } from 'ui/router';

import { Footer, Header } from '../SectionBuilder/sections';

import { SectionBuilder } from '../SectionBuilder';
import { selectors as userSelectors } from 'core/use-cases/user';
import {
  useComboApplicationWrapper,
  useRedirectBlockedUser,
  useEventResellerId,
  useTapume,
  useLogoutApplicationWrapper,
} from './hooks';

const ApplicationWrapper = () => {
  const { status: statusRequest } = userSelectors.useUserSelector();

  useLogoutApplicationWrapper();
  useRedirectBlockedUser();
  useEventResellerId();
  useTapume();
  useComboApplicationWrapper();

  if (statusRequest === Utilities.STATUS.RUNNING) {
    return <LoaderFullScreen message="" />;
  }

  return (
    <>
      <Header />
      <StackNavigatorProvider>
        <>
          <Routes />
          <SectionBuilder />
          <Notification />
        </>
      </StackNavigatorProvider>
      <Footer />
      <Loader />
    </>
  );
};

export default ApplicationWrapper;
